import {
  CompactEstimatorTempateResponse,
  EstimatorTempateId,
  FormulaResponse,
  TmEstimatorTempateResponse,
} from '@business/entities/tm/TmTemplateEstimatorResponse';
import { Endpoint } from '../endpoint';
import { R } from '@core/utils/r';
import { EstimateTemplateFormData } from '@modules/settings/SettingsPage/Components/EstimateTab/AddEditEstimatorTempateModal/EstimateTemplateForm';

export function fetchEstimatorTempates(isCompact: boolean) {
  const params = R.objectCompact({ isCompact });
  return Endpoint.get<CompactEstimatorTempateResponse[]>(`@gc/estimator-templates`, { params });
}

export function fetchEstimatorTempate(id: EstimatorTempateId) {
  return Endpoint.get<TmEstimatorTempateResponse>(`@gc/estimator-templates/estimate-template/${id}`);
}

export function createEstimatorTempate(data: EstimateTemplateFormData) {
  return Endpoint.post<TmEstimatorTempateResponse>(`@gc/estimator-templates`, { data });
}

// changeNote: the reason for the change (required, kept in the Activity Log)
export function updateEstimatorTempate(id: EstimatorTempateId, data: EstimateTemplateFormData, changeNote: string) {
  return Endpoint.patch<TmEstimatorTempateResponse>(`@gc/estimator-templates/${id}`, { data: { ...data, changeNote } });
}

export function deleteEstimatorTempate(id: EstimatorTempateId, changeNote: string) {
  return Endpoint.delete<void>(`@gc/estimator-templates/${id}`, { data: { changeNote } });
}

export function validateFormula(data: { formula: string }) {
  return Endpoint.post<FormulaResponse>(`@gc/estimator-templates/validate-formula`, { data });
}
